/* eslint-disable */

import { Swiper, Pagination, Navigation } from 'swiper';

const breakpoint = window.matchMedia('(min-width: 1224px)');
Swiper.use([Pagination, Navigation]);

let mySliders = [];

function enableSwiper() {
  const sliderElements = document.querySelectorAll('.swiper-grid .swiper-container');

  if (!sliderElements.length > 0) return;

  sliderElements.forEach((el) => {
    const id = el.getAttribute('data-swiper-id');

    const slider = new Swiper(el, {
      loop: false,
      spaceBetween: 10,
      centeredSlidesBounds: true,
      centeredSlides: true,
      slidesPerView: 1.2,
      a11y: true,
      keyboardControl: true,
      grabCursor: true,
      autoHeight: false,
      navigation: {
        nextEl: `.swiper-grid[data-swiper-id="${id}"] .swiper-button-next`,
        prevEl: `.swiper-grid[data-swiper-id="${id}"] .swiper-button-prev`,
      },
      pagination: {
        el: `.swiper-grid[data-swiper-id="${id}"] .swiper-pagination`,
        clickable: true,
      },
      breakpoints: {
        650: {
          slidesPerView: 2.2,
          spaceBetween: 20,
          centeredSlides: false,
          centeredSlidesBounds: false,
        },

        768: {
          centeredSlides: false,
          centeredSlidesBounds: false,
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
      },
    });

    mySliders.push(slider);
  });
}

function swiperBreakpointChecker() {
  // if larger viewport and multi-row layout needed

  if (breakpoint.matches === true) {
    if (mySliders.length > 0) {
      for (let index = 0; index < mySliders.length; index += 1) {
        const mySwiper = mySliders[Number(index)];

        if (mySwiper !== undefined) mySwiper.destroy(true, true);
      }
      mySliders = [];
    }
  } else {
    enableSwiper();
  }
}

breakpoint.addEventListener('change', swiperBreakpointChecker);

function latestDocumentsSwiper() {
  const slider = new Swiper('.latest-documents .latest-documents-swiper', {
    loop: false,
    spaceBetween: 10,
    centeredSlidesBounds: true,
    centeredSlides: true,
    slidesPerView: 1.4,
    a11y: true,
    keyboardControl: true,
    grabCursor: false,
    autoHeight: false,
    navigation: {
      nextEl: '.latest-documents .swiper-button-next',
      prevEl: '.latest-documents .swiper-button-prev',
    },
    pagination: {
      el: '.latest-documents .swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerGroup: 2,
        slidesPerView: 2,
        spaceBetween: 20,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
        slidesPerGroup: 3,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
      1224: {
        slidesPerView: 4,
        spaceBetween: 20,
        slidesPerGroup: 4,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
    },
  });
}

window.addEventListener('load', () => {
  swiperBreakpointChecker();
  latestDocumentsSwiper();
});
